module.exports = __webpack_public_path__ + "media/PAG73-05.24ef04ec.mp3";